/* eslint-disable import/no-unresolved */

/*
Pełnoekranowy loader na czas wysyłki formularza - ten sam komponent, który pokazuje
checkout przy składaniu zamówienia (CharitySubmitLoader). Vue i komponent przychodzą
osobnym chunkiem dopiero, gdy formularz jest potrzebny (jak BlogRelatedProducts
w blog.js), więc sama gra nie płaci za Vue.
*/

let loader = null;

async function mountLoader(texts) {
    const [{ createApp, h, ref }, { default: CharitySubmitLoader }] = await Promise.all([
        import('vue'),
        import(
            /* webpackChunkName: "charity-submit-loader" */ '@vuejs/components/product/CharitySubmitLoader.vue'
        ),
    ]);

    const visible = ref(false);
    const el = document.createElement('div');

    document.body.append(el);

    createApp({
        render: () =>
            h(
                CharitySubmitLoader,
                {
                    show: visible.value,
                    eyebrow: texts.loader_eyebrow,
                    titleLead: texts.loader_title,
                    // Ciepłe złoto na tle --rpm-stone, teksty w tuszu landingu (--rpm-ink).
                    accentRgb: '176, 148, 102',
                    accentSoftRgb: '204, 186, 152',
                    backdropRgb: '246, 245, 243',
                    textAccentRgb: '29, 28, 28',
                },
                { default: () => [h('strong', texts.loader_warning), ` ${texts.loader_info}`] }
            ),
    }).mount(el);

    return {
        show: () => {
            visible.value = true;
        },
        hide: () => {
            visible.value = false;
        },
    };
}

// Loader albo null, gdy chunk się nie załaduje - wtedy formularz wysyła się bez niego.
export function loadLoader(texts) {
    loader ??= mountLoader(texts).catch(() => {
        loader = null;

        return null;
    });

    return loader;
}
